import {
	SNOWPLOW_ENTITY,
	SNOWPLOW_ENTITY_DATA,
	SNOWPLOW_ENTITY_ENUM,
	SNOWPLOW_ENVIRONMENT,
} from "./conf";
import {
	getSnowplowEntitySchema,
	isValidSnowplowEntity,
	snowplowLog,
	snowplowStructGenerator,
} from "./utils";

export const getSnowplowPlatformCode = ({ properties = {} } = {}) => {
	if (!properties || typeof properties !== "object") return undefined;

	let code = undefined;

	// eslint-disable-next-line no-extra-boolean-cast
	if (!!properties?.shopify_shop) {
		code = SNOWPLOW_ENTITY_ENUM[SNOWPLOW_ENTITY.PLATFORM].CODE.SHOPIFY;
	}

	return code;
};

export const getSnowplowPlacementDetails = ({ properties = {} } = {}) => {
	if (!properties || typeof properties !== "object") return undefined;

	const pageType = properties?.page_type;
	const transformedPageType =
		pageType &&
		SNOWPLOW_ENTITY_ENUM[SNOWPLOW_ENTITY.SESSION_CONFIGURATION]
			.PLACEMENT_DETAILS.VIEW[pageType];

	return {
		...(transformedPageType && { view: transformedPageType }),
	};
};

export const snowplowProductsFormatter = ({ products = [] } = {}) => {
	let parsedProducts = products;

	if (typeof parsedProducts === "string") {
		try {
			parsedProducts = JSON.parse(products);
		} catch (err) {
			snowplowLog("snowplowProductsFormatter >>", "Invalid products");
		}
	}

	if (!Array.isArray(parsedProducts)) return undefined;
	return parsedProducts
		.map((product) => ({
			id: product.product_id,
			name: product.name,
			variant: product.variant,
			quantity: product.quantity,
			scraped: product.scraped,
		}))
		.map(({ id, quantity, name, ...product }) => ({
			// id: !isNaN(id) ? Number(id) : undefined,
			id: String(id),
			name: typeof name === "string" ? name.slice(0, 999) : name,
			quantity:
				quantity && !isNaN(quantity) ? Number(quantity) : undefined,
			...product,
		}));
};
export const snowplowRunningExperimentsFormatter = ({
	runningExperiments = {},
} = {}) => {
	if (typeof runningExperiments !== "object") return undefined;

	return Object.entries(runningExperiments).map(([experiment, version]) => ({
		name: experiment,
		version: version,
	}));
};

export const snowplowNumPriceFormatter = ({ price = "" } = {}) => {
	if (typeof price !== "string") return undefined;
	let numPrice = price.replace("$", "").trim();

	if (isNaN(numPrice)) return undefined;
	numPrice = Number(numPrice).toFixed(2);
	if (isNaN(numPrice)) return undefined;
	return Number(numPrice);
};

export const snowplowPriceFormatter = ({ price = "" } = {}) => {
	if (typeof price === "number") return price;
	return snowplowNumPriceFormatter({ price });
};

export const snowplowEntityAttacher = ({
	entities = [],
	additionalEntity = null,
	canAttachEntity = true,
} = {}) => {
	if (!additionalEntity || !canAttachEntity) return entities;
	return [...entities, additionalEntity];
};

export const snowplowEntityGenerator = ({
	entity = "",
	environment = SNOWPLOW_ENVIRONMENT.PRODUCTION,
	properties = {},
	propertyMapper = {}, // entity property => input property
	additionalProperties = {},
} = {}) => {
	if (!isValidSnowplowEntity({ entity })) {
		snowplowLog("snowplowEntityGenerator >>", "Invalid entity");
		return null;
	}
	const entitySchema = getSnowplowEntitySchema({ environment, entity });

	const entityData = SNOWPLOW_ENTITY_DATA[entity].reduce(
		(map, entityProperty) => {
			const targetPropertyKey =
				propertyMapper?.[entityProperty] || entityProperty;
			return {
				...map,
				...(targetPropertyKey in properties && {
					[entityProperty]: properties?.[targetPropertyKey],
				}),
			};
		},
		{}
	);

	return snowplowStructGenerator({
		schema: entitySchema,
		data: { ...entityData, ...additionalProperties },
	});
};
